export const formatDataValue = (value, type = "string") => {
    if (value === undefined || value === null) return "-";

    switch (type) {
        case "currency":
            return typeof value === "number"
                ? `$${value.toLocaleString("en-US", { minimumFractionDigits: 2 })}`
                : "-";

        case "date":
            return value ? new Date(value).toLocaleDateString("en-US") : "-";

        default:
            return value;
    }
};

export const transformTableData = (data, options = {}) => {
    if (!data || data.length === 0) return [];

    return data.map((item) => {
        const newItem = { ...item };

        Object.keys(newItem).forEach((key) => {
            // Handle specific field types
            if (options.currencyFields?.includes(key)) {
                newItem[key] = formatDataValue(newItem[key], "currency");
            } else if (options.dateFields?.includes(key)) {
                newItem[key] = formatDataValue(newItem[key], "date");
            } else {
                newItem[key] = formatDataValue(newItem[key]);
            }
        });

        return newItem;
    });
};
